import { useEffect, useState } from 'react';
import Script from 'next/script';

export const YotpoReviewScript = () => {
  const [showReviews, setShowReviews] = useState(false);
  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      (window as any).yotpoWidgetsContainer?.initWidgets
    ) {
      (window as any).yotpoWidgetsContainer.initWidgets();
    } else {
      console.error('Yotpo initWidgets function is not available.');
    }
  }, [showReviews]);

  return (
    <Script
      src={`https://cdn-widgetsrepository.yotpo.com/v1/loader/${process.env.NEXT_PUBLIC_YOTPO_APP_KEY}`}
      async
      onReady={() => {
        setShowReviews(true);
      }}
    />
  );
};
